export class SvgIcon extends HTMLElement {
    static observedAttributes = ["code"];
    shadow = null;
    connectedCallback() {
        const shadow = this.attachShadow({ mode: 'open' });
        this.shadow = shadow;
        shadow.innerHTML = this.getAttribute('code');
    }

    attributeChangedCallback(name, oldValue, newValue) {
        switch (name) {
            case "code":
                if (oldValue !== newValue && this.shadow) {
                    this.shadow.innerHTML = newValue;
                }
                break;
            default: return;
        }
    }
}